
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';

import { getIcon  } from 'utils/misc';

function LoadingSection({copy="Loading..."}: {copy?: string}) {
    const LoadingIcon = getIcon('Replay');
    return (
        <Stack
            m={3}
            height="100%"
            direction="row"
            justifyContent="center"
            justifyItems="center">
            <Typography
                endDecorator={<LoadingIcon
                                  sx={{
                                      animation: "backspin 1.4s linear infinite"
                                  }}
                />}
                level="body-xs">
                { copy }
            </Typography>
        </Stack>
    );
}
export default LoadingSection
